import { ReactNode } from 'react';
import { Track } from '../../../components/ui';

export interface TrackRowItem {
  key: string;
  label: ReactNode;
  count: number;
  /** Share of the whole, 0-100. */
  pct: number;
  tone?: 'slate' | 'accent' | 'danger';
  /** Plain-text name for the progress bar. */
  ariaLabel: string;
}

/** Design `.hb`: a 13px label, a share bar and a count per row (120px | 1fr | 40px). */
export default function TrackRows({ rows }: { rows: TrackRowItem[] }) {
  return (
    <ul>
      {rows.map((r) => (
        <li key={r.key} className="grid grid-cols-[minmax(0,120px)_minmax(0,1fr)_40px] items-center gap-3 py-1.5 text-[13px]">
          <span className="truncate">{r.label}</span>
          <Track value={r.pct} tone={r.tone} label={r.ariaLabel} />
          <span className="text-right font-mono font-medium tabular-nums">{r.count}</span>
        </li>
      ))}
    </ul>
  );
}
